import React, { FC, memo, ReactElement, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useAuth0 } from '@auth0/auth0-react';
import BootstrapAvatar from '../BootstrapAvatar';
import { ChatHeadDto } from '../../../../shared/dtos/chat.dto';

type Props = {
  therapies: ChatHeadDto[],
  selectedTherapy: ChatHeadDto | null,
  handleSelectTherapy: (therapy: ChatHeadDto) => void;
};

const ChatHeadHorizontalComponent: FC<Props> = ({ therapies, handleSelectTherapy, selectedTherapy }) => {
  const { user } = useAuth0();
  
  const localOnlineUsers = localStorage.getItem('_online_');
  const onlineUsers = localOnlineUsers ? localOnlineUsers.split(',') : [];
  
  const [therapyList, setTherapyList] = useState<ChatHeadDto[]>([]);
  const [selectedTherapyId, setSelectedTherapyId] = useState<string>(selectedTherapy? selectedTherapy.id:'');
  
  const changeChatHead = (therapy: ChatHeadDto): void => {
    if (therapy) {
      setSelectedTherapyId(therapy.id);
      handleSelectTherapy(therapy);
    }
  };

  useEffect(() => {
    if (therapies && therapies.length > 0) {
      setTherapyList(therapies);
      sortTherapyList(therapies);
    }
  }, [therapies]);

  const renderChatHead = (therapy: ChatHeadDto, index: number): ReactElement | null => {
    if (therapy) {
      const selected = selectedTherapyId === therapy.id ? 'chat-head-selected' : '';
      return (
        <Card key={'chatHead-' + index} className={`flex-shrink-1 chat-card m-2 ${selected}`} onClick={() => { changeChatHead(therapy); }}>
          <Card.Body className="text-center pb-0">
            <BootstrapAvatar
              name={`${therapy.patientFirstName} ${therapy.patientLastName}`}
              size={40}
              color="#707089"
              className="rounded-circle me-1"
              round={true}
            />
            <p className="pt-3"> {therapy.patientFirstName ? therapy.patientFirstName.substring(0, 10) : ''}</p>
          </Card.Body>
        </Card>
      );
    }
    return null;

  };
  const renderOnlineUser = (): ReactElement | undefined => {
    const topTherapy =
      therapyList.filter((x) => onlineUsers.indexOf(x.patientId) >= 0 && x.patientAccountId !== user?.sub);
    if (topTherapy && topTherapy.length > 0) {
      return (<>
        {therapyList.filter((x) => onlineUsers.indexOf(x.patientId) >= 0 && x.patientAccountId!== user?.sub)
          .map((therapy, index) => {
            return renderChatHead(therapy, index);
          })}
      </>);
    }
  };
  const renderOfflineUserLastMessage = (): ReactElement => {
    return (<>
      {therapyList
        .filter((x) => x.lastMessageDate === null && onlineUsers.indexOf(x.patientId) < 0 && x.patientAccountId !== user?.sub)
        .map((therapy, index) => {
          return renderChatHead(therapy, index);
        })}
    </>);
  };
  const renderOfflineUser = (): ReactElement => {
    return (<>
      {therapyList
        .filter((x) => x.lastMessageDate !== null && onlineUsers.indexOf(x.patientId) < 0 && x.patientAccountId !== user?.sub)
        .map((therapy, index) => {
          return renderChatHead(therapy, index);
        })}
    </>);
  };
  const renderTherapistUser = (): ReactElement => {
    return (<>
      {therapyList.filter((x) => x.patientAccountId === user?.sub).map((therapy, index) => {
        return renderChatHead(therapy, index);
      })}
    </>);
  };
  const sortTherapyList = (tList: ChatHeadDto[]): void => {
    if (isEmpty(selectedTherapy)) {
      let topTherapy = tList.filter((x) => onlineUsers.indexOf(x.patientId) >= 0 && x.patientAccountId !== user?.sub);
      topTherapy = topTherapy.length === 0 ?
        tList.filter((x) => x.lastMessageDate !== null && onlineUsers
          .indexOf(x.patientId) < 0 && x.patientAccountId !== user?.sub) :
        topTherapy;
      topTherapy = topTherapy.length === 0 ?
        tList.filter((x) => x.lastMessageDate === null && onlineUsers
          .indexOf(x.patientId) < 0 && x.patientAccountId !== user?.sub) :
        topTherapy;
      topTherapy = topTherapy.length === 0 ? tList.filter((x) => x.patientAccountId === user?.sub) : topTherapy;
      
      if (topTherapy && topTherapy.length > 0) {
        handleSelectTherapy(topTherapy[0]);
        setSelectedTherapyId(topTherapy[0].id);
      }
    }
  };
  return (
    <>
      {therapyList && therapyList.length !== 0 ? <div className="row flex-nowrap horizontal-scroll">
        {renderOnlineUser()}
        {renderOfflineUser()}
        {renderOfflineUserLastMessage()}
        {renderTherapistUser()}
      </div> : null}</>
  );
};

export default memo(ChatHeadHorizontalComponent);
